import * as React from 'react';
import { Link } from 'react-router-dom';
import './style.css';

export interface TagProps {
  className?: string;
  colour: string;
  href?: string;
  text: string;
  tooltip?: string;
}

export interface TagState {
  /* empty*/
}

export class Tag extends React.Component<TagProps, TagState> {
  render() {
    const { href } = this.props;

    return href ? this.getTagLink(href) : this.getStaticTag();
  }

  private getTagLink = (href: string): JSX.Element => {
    const { className, colour, text, tooltip } = this.props;

    return (
      <Link
        className={`tag tag-link${
          className ? ` ${className} ${className}-link` : ``
        }`}
        style={{ backgroundColor: colour }}
        title={tooltip}
        to={href}
      >
        {text}
        {this.props.children}
      </Link>
    );
  };

  private getStaticTag = (): JSX.Element => {
    const { className, colour, text, tooltip } = this.props;

    return (
      <span
        className={`tag tag-static${
          className ? ` ${className} ${className}-static` : ``
        }`}
        style={{ backgroundColor: colour }}
        title={tooltip}
      >
        {text}
        {this.props.children}
      </span>
    );
  };
}

export default Tag;



// WEBPACK FOOTER //
// ./src/app/components/Common/Tag/index.tsx